var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2355_786",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2355_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.925 11.5502L8.675 7.3002L10.1 5.9002L12.925 8.7252L18.6 3.0752L20 4.4752L12.925 11.5502ZM7 19.0002L13.95 20.9002L19.9 19.0502C19.8167 18.9002 19.6958 18.771 19.5375 18.6627C19.3792 18.5544 19.2 18.5002 19 18.5002H13.95C13.5 18.5002 13.1417 18.4835 12.875 18.4502C12.6083 18.4169 12.3333 18.3502 12.05 18.2502L9.725 17.4752L10.275 15.5252L12.3 16.2002C12.5833 16.2835 12.9167 16.3502 13.3 16.4002C13.6833 16.4502 14.25 16.4835 15 16.5002C15 16.3169 14.9458 16.1419 14.8375 15.9752C14.7292 15.8085 14.6 15.7002 14.45 15.6502L8.6 13.5002H7V19.0002ZM1 22.5002V11.5002H8.6C8.71667 11.5002 8.83333 11.5127 8.95 11.5377C9.06667 11.5627 9.175 11.5919 9.275 11.6252L15.15 13.8002C15.7 14.0002 16.1458 14.3502 16.4875 14.8502C16.8292 15.3502 17 15.9002 17 16.5002H19C19.8333 16.5002 20.5417 16.7752 21.125 17.3252C21.7083 17.8752 22 18.6002 22 19.5002V20.5002L14 23.0002L7 21.0502V22.5002H1ZM3 20.5002H5V13.5002H3V20.5002Z",
    fill: "#4D2481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalHand);
export default __webpack_public_path__ + "static/media/approval-hand.289a90f42c7d929309cb362e0f25053a.svg";
export { ForwardRef as ReactComponent };